import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";

interface RecordTableTreeControlsProps {
    expandAll: () => void;
    collapseAll: () => void;
}

/**
 * Expand-all / collapse-all for a grouped or tree table. Both act in place, so
 * they are real buttons (ui-design-principle-buttons), not link-styled text.
 */
export const RecordTableTreeControls = ({ expandAll, collapseAll }: RecordTableTreeControlsProps) => (
    <span className="recordTableTreeControls">
        <Button
            variation="white"
            size="small"
            icon={IconCollection.arrowExpand}
            label="Expand all"
            title="Expand all"
            onClick={expandAll}
        />
        <Button
            variation="white"
            size="small"
            icon={IconCollection.arrowCollapse}
            label="Collapse all"
            title="Collapse all"
            onClick={collapseAll}
        />
    </span>
);
